import React from 'react';

export enum SpinnerSize {
    Small = 'spinner--small',
    Large = 'spinner--large'
}

interface IOwnProps {
    size?: SpinnerSize;
    isFormSpinner?: boolean;
}

type Props = IOwnProps;

class Spinner extends React.Component<Props, {}> {
    public render() {
        return this.props.isFormSpinner ?
            <div className="form__section__inner">
                {this.renderSpinner}
            </div>
            :
            this.renderSpinner;
    }

    private get renderSpinner() {
        return <span className={'spinner'.cAppend(this.props.size, this.props.size)} />;
    }
}

export default Spinner;